// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

// src/pages/admin/home.jsx
export default function AdminHome() {
  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold text-gray-900">Admin</h1>
      <p className="text-sm text-gray-400">Coming soon.</p>
    </div>
  );
}
